<template>
    <div class="bg-[#222225E5] relative bg-opacity-90 text-center w-full h-9 overflow-hidden cursor-pointer">
        <div class="flex z-20 relative items-center justify-center space-x-2 text-body-md pointer-events-none">
            <div v-html="message" class="text-gray-100 text-body-sm lg:text-body-md" />
            <span v-if="link" class="text-brand-300 underline cursor-pointer">{{ link }}</span>
        </div>
        <div
            class="absolute bg-[#AF0DD7] bg-opacity-30 rounded-full z-10 -translate-x-1/2 -translate-y-1/2 blur-3xl pointer-events-none h-12"
            :style="{
                left: `${x}px`,
                top: `${y}px`,
                width: '600px',
                height: '300px',
            }"
        />
    </div>
</template>

<script setup lang="ts">
interface IOfferBannerProps {
    message: string;
    link?: string;
}

withDefaults(defineProps<IOfferBannerProps>(), {
    message: "Banner <b>Message</b>",
});

const parentEl = useCurrentElement();

const { x, y } = useMouse({
    touch: false,
    target: parentEl as MaybeRefOrGetter<EventTarget | Window | null | undefined>,
});
</script>
